import type { FC } from "react";
import { Seo } from "src/components/seo";
import HomeFeatures from "src/sections/home/home-features";

const PricingPage: FC = () => (
  <>
    <Seo
      title="Nightscout Hosting and Coaching Prices"
      description="Compare hosted Nightscout and diabetes coaching plans, with monthly or yearly billing and setup help for AndroidAPS and open-source looping."
      type="website"
    />
    <HomeFeatures />
  </>
);

export default PricingPage;
